import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';
import GroupList from './subComponents/GroupList';
import { Info } from '@components/Common/Icons';
import SlidePage from '@components/Common/SlidePage';
import { I_DirectionList as I_DirectionListSearch } from '@Redux/search/interfaces';
import { I_DirectionList as I_DirectionListDetail } from '@Redux/detail/Group/interfaces';

interface I_Props {
    directionList: I_DirectionListSearch[] | I_DirectionListDetail[] | undefined;
    open: boolean;
    ToggleLightBox: () => void;
    storyData?: {
        url: string;
    };
}

const GroupTripInfoFlight: React.FC<I_Props> = ({ open, ToggleLightBox, directionList }) => {
    const isPC = useMediaQuery({ query: '(min-width: 980px)' });    

    return isPC ? (
        <LightBox
            title="航班詳情"
            subTitle={
                <div className={cN(styles['tips'])}>
                    <span className={cN(styles['icon-wrap'])}>
                        <Info />
                    </span>
                    <span className={cN(styles['text'])}>
                        航班時間僅為參考，最終確定之使用航班，以說明會資料為準！
                    </span>
                </div>
            }
            open={open}
            ToggleLightBox={ToggleLightBox}
            className={cN(styles.container, 'group_tripinfo_flight')}
        >
            <GroupList directionList={directionList} />
        </LightBox>
    ) : (
        <SlidePage
            visible={open}
            title="航班詳情"
            setIsVisible={ToggleLightBox}
            side="bottom"
        >
            <div className={cN(styles['flightInfo'])}>
                <div className={cN(styles['tips'])}>
                    <span className={cN(styles['icon-wrap'])}>
                        <Info />
                    </span>
                    <span>航班時間僅為參考，最終確定之使用航班，以說明會資料為準！</span>
                </div>
                <GroupList directionList={directionList} />
            </div>
        </SlidePage>
    );
};

export default GroupTripInfoFlight;
